<template>
  <div class="campaign-payment-option">
    <div class="campaign-payment-option__identity">
      <span class="campaign-payment-option__name">{{ item.name }}</span>
      <span v-if="item.ioNumber" class="campaign-payment-option__io">{{ item.ioNumber }}</span>
    </div>

    <div class="campaign-payment-option__statuses">
      <v-chip v-if="item.statusLoading" color="grey" small>
        <span class="campaign-payment-option__chip-text">Checking status…</span>
      </v-chip>
      <v-chip v-else-if="item.statusUnavailable" color="grey darken-1" small>
        <span class="campaign-payment-option__chip-text">Status unavailable</span>
      </v-chip>
      <template v-else>
        <v-chip color="error" v-if="item.payoutStatus !== payoutStatus.CONFIRMED" small>
          <span class="campaign-payment-option__chip-text"><v-icon small left>warning</v-icon> Pending Payout Confirmation</span>
        </v-chip>
        <v-chip color="green" v-else small>
          <span class="campaign-payment-option__chip-text"><v-icon small left>done</v-icon> Payouts Confirmed</span>
        </v-chip>

        <v-chip color="error" v-if="!item.inReport" small>
          <span class="campaign-payment-option__chip-text"><v-icon small left>warning</v-icon> Pending in Report</span>
        </v-chip>
        <v-chip color="green" v-else small>
          <span class="campaign-payment-option__chip-text"><v-icon small left>done</v-icon> Present in Report</span>
        </v-chip>
      </template>
    </div>
  </div>
</template>
<script>
import campaignConfig from '../config';
export default {
  name: 'CampaignListPaymentStatus',
  props: ['item'],
  data() {
    return {
      payoutStatus: campaignConfig.payoutStatus
    }
  }
}
</script>
<style scoped>
.campaign-payment-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  min-width: 0;
}

.campaign-payment-option__identity {
  flex: 1 1 auto;
  min-width: 220px;
  overflow: hidden;
}

.campaign-payment-option__name,
.campaign-payment-option__io {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.campaign-payment-option__name {
  color: var(--ims-color-ink, #1a1a1a);
  font-weight: 600;
}

.campaign-payment-option__io {
  color: var(--ims-color-muted, #6b7280);
  font-size: 12px;
  margin-top: 2px;
}

.campaign-payment-option__statuses {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
}

.campaign-payment-option__statuses .v-chip {
  margin: 0;
}

.campaign-payment-option__chip-text {
  color: #fff;
}

@media (max-width: 900px) {
  .campaign-payment-option {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .campaign-payment-option__identity {
    min-width: 0;
    width: 100%;
  }

  .campaign-payment-option__statuses {
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// CampaignListPaymentStatus.vue?02104264